// extracted by mini-css-extract-plugin
module.exports = {"dateIcon":"styles_dateIcon__xUSM_","datepicker":"styles_datepicker__0bNyi","large":"styles_large___38iI","xlarge":"styles_xlarge__1mnMq"};